<template>
  <div class="RolesList">
    <modal
      name="AddMenu"
      width="60%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="true"
      style="overflow:scroll"
    >
      <FormAddMenu labelAction="Agregar Item" :method="reloadMenu" v-if="renderComponent1" />
    </modal>
    <modal
      name="EditMenu"
      width="60%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="true"
      style="overflow:scroll"
    >
      <FormEditMenu
        labelAction="Editar Item"
        :method="reloadMenu"
        :ModelForm="formUpdate"
        v-if="renderComponent2"
      />
    </modal>
    <div class="titlePage">Administracion - Roles y Permisos</div>
    <va-notification
      color="danger"
      v-if="refNoMenu"
      class="refNoData"
    >El servicio que ejecuta el llamado del menú no se encuentra activo.</va-notification>
    <va-notification
      color="danger"
      v-if="refNoRol"
      class="refNoData"
    >El servicio que ejecuta el llamado de los roles no se encuentra activo.</va-notification>
    <div v-if="dataList" class="MenuData table-responsive">
      <table class="table table-hover" id="myTable">
        <thead>
          <tr>
            <th scope="col" colspan="2">Menu</th>
            <template v-for="itemRol of this.dataRol">
              <th
                scope="col"
                :key="itemRol.idRole"
                class="text-center"
                v-if="itemRol.idRole != 1"
              >
                <span>{{itemRol.namRole}}</span>
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <template v-for="item of dataMenu">
            <tr class="item" :key="item.Id_Menu">
              <th scope="row">
                <va-icon
                  class="iconListMenu"
                  title="Menú"
                  alt="Menú"
                  v-if="item.children"
                  name="fa fa-chevron-down"
                  size="60"
                />
                <va-icon
                  class="iconListMenu"
                  title="Menú"
                  alt="Menú"
                  v-else
                  name="fa fa-chevron-right"
                  size="60"
                />
              </th>
              <td>{{item.Nam_Menu}}</td>
              <template v-for="itemRolList of dataRol">
                <td
                  class="status text-center"
                  :key="itemRolList.idRole"
                  v-if="itemRolList.idRole != 1"
                >
                      <div class="custom-control custom-checkbox mr-sm-2">
                          <input
                          v-model="modelArray[item.Id_Menu + '_' + itemRolList.idRole]"
                          type="checkbox"
                          :id="item.Id_Menu + '_' + itemRolList.idRole"
                          class="custom-control-input"
                          />
                          <label class="custom-control-label" :for="item.Id_Menu + '_' + itemRolList.idRole" :alt="item.Nam_Menu + ' | ' + itemRolList.namRole" :title="item.Nam_Menu + ' | ' + itemRolList.namRole"></label>
                      </div>
                </td>
              </template>
            </tr>
            <template v-if="item.children">
              <tr class="item" :key="itemc.Id_Menu" v-for="itemc of item.children">
                <th scope="row">
                  <va-icon
                    class="iconListSubMenu"
                    title="Submenú"
                    alt="Submenú"
                    name="fa fa-level-up"
                    size="120"
                    rotation="90"
                  />
                </th>
                <td>{{itemc.Nam_Menu}}</td>
                <template v-for="itemRolList of dataRol">
                  <td
                    class="status text-center"
                    :key="itemRolList.idRole"
                    v-if="itemRolList.idRole != 1"
                  >
                      <div class="custom-control custom-checkbox mr-sm-2" >
                          <input
                          v-model="modelArray[itemc.Id_Menu + '_' + itemRolList.idRole]"
                          type="checkbox"
                          :id="itemc.Id_Menu + '_' + itemRolList.idRole"
                          class="custom-control-input"
                          />
                          <label class="custom-control-label" :for="itemc.Id_Menu + '_' + itemRolList.idRole" :alt="itemc.Nam_Menu + ' | ' + itemRolList.namRole" :title="itemc.Nam_Menu + ' | ' + itemRolList.namRole"></label>
                      </div>
                  </td>
                </template>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
      <div class="text-right">
          <button class="loginbtn primaryBtn" type="submit" v-on:click="this.processRoles">
            <va-icon name="fa fa-database" size="60" /> Actualizar Roles y Permisos
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'RolesList',
  components: {
    IberoHelpers,
  },
  data () {
    return {
      dataMenu: [],
      modelArray: {},
      dataRol: [],
      dataList: false,
      ModeldataRol: [],
      refNoMenu: false,
      refNoRol: false,
      formUpdate: [],
      renderComponent1: false,
      renderComponent2: false,
    }
  },
  methods: {
    processRoles () {
      let loader = this.$loading.show()
      this.ModeldataRol.length = 0
      for (const items in this.modelArray) {
        if (this.modelArray[items] === true) {
          var listDataMR = items.split('_')
          this.ModeldataRol.push({ IdId_Menu: listDataMR[0], IdId_Role: listDataMR[1] })
        }
      }
      var RolByMenuData = IberoHelpers.updateRoleByMenu(this.$store, this.ModeldataRol)
      RolByMenuData.then(Response => {
        if (Response.data) {
          this.reloadMenu()
          loader.hide()
        } else {
          loader.hide()
        }
      })
    },
    reloadMenu () {
      let loader = this.$loading.show()
      window.location.reload()
      loader.show()
    },
    evalMenuRol (IdMenu, ListRol, RolMenu) {
      for (var j = 0; j < ListRol.length; j++) {
        var refen = IdMenu + '_' + ListRol[j].idRole
        if (ListRol[j].idRole === 1) {
          this.modelArray[refen] = true
        } else {
          var dataMenu = RolMenu.filter(item => {
            if (item.Id_Menu === IdMenu && item.Id_Role === ListRol[j].idRole) {
              return item
            }
          })
          if (dataMenu.length === 1) {
            this.modelArray[refen] = true
          } else {
            this.modelArray[refen] = false
          }
        }
      }
    },
    loadListMenu () {
      let loader = this.$loading.show()
      var MenuData = IberoHelpers.getMenuData(this.$store, 3, 0)
      MenuData.then(Response => {
        if (Response.data) {
          this.dataMenu = Response.data
          var RolData = IberoHelpers.getRolData(this.$store)
          RolData.then(Response => {
            if (Response.data) {
              this.dataRol = Response.data
              var RolByMenuData = IberoHelpers.getRolByMenuData(this.$store)
              RolByMenuData.then(Response => {
                if (Response.data) {
                  for (var i = 0; i < this.dataMenu.length; i++) {
                    this.evalMenuRol(this.dataMenu[i].Id_Menu, this.dataRol, Response.data)
                    if (!(typeof this.dataMenu[i].children === 'undefined')) {
                      for (var j = 0; j < this.dataMenu[i].children.length; j++) {
                        this.evalMenuRol(this.dataMenu[i].children[j].Id_Menu, this.dataRol, Response.data)
                      }
                    }
                  }
                  this.dataList = true
                  loader.hide()
                } else {
                  this.refNoRol = true
                  loader.hide()
                }
              })
            } else {
              this.refNoRol = true
            }
          })
        } else {
          this.refNoMenu = true
        }
      })
    },
  },
  created: function () {
    this.loadListMenu()
  },
}
</script>

<style scoped>
.refNoData {
  padding: 10px;
  padding-left: 20px;
  margin-top: 30px;
  margin-bottom: 10px;
}
.MenuData {
  margin-top: 20px;
}

.table thead th {
  border-bottom: 2px solid #222 !important;
  font-weight: bold;
}

.loginbtn {
  width: 30% !important;
}

table.table-hover tbody tr:hover {
  background-color: #f1e2e5 !important;
}

.imgdata {
  margin-left: 2px !important;
  margin-right: 2px !important;
}

.iconListMenu {
  margin-right: 10px;
}

.iconListSubMenu {
  margin-right: 10px;
  margin-left: 10px;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::before{
  background-color:#F65A6F;
}
</style>